import { render, staticRenderFns } from "./UserAccountBillingTabs.vue?vue&type=template&id=10f23d4a&"
import script from "./UserAccountBillingTabs.vue?vue&type=script&lang=js&"
export * from "./UserAccountBillingTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports